import React from "react";
import {connect} from "react-redux";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  CheckBox,
  DatePicker,
} from "../../components";
import {axios, Constants, Globals, Format, ENV} from "../../utils";
import {Branch, Warehouse, Category, Brand} from "../../services";
import PrinterIcon from "../../assets/icons/printer.png";

class ReportProviders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      thead: [],
      trows: [],
      total: 0,
      header: [
        {
          value: "seller",
          label: "Proveedor",
          type: 1,
          section: "required",
          order: 0,
          align: "left",
        },
        {
          value: "total",
          label: "Total ($)",
          type: 1,
          section: "required",
          order: 1,
          align: "center",
        },
        {
          value: "total_bs",
          label: "Total (Bs)",
          type: 1,
          section: "required",
          order: 1,
          align: "right",
        },
      ],
      optionals: [
        {value: "code", label: "Código", show: true},
        {value: "name", label: "Nombre", show: true},
        {value: "branch", label: "Almacen", show: true},
        {value: "warehouse", label: "Almacen", show: true},
        {value: "current_stock", label: "Existencia", show: true},
        {value: "available", label: "Disponible", show: true},
        {value: "total", label: "Total", show: true},
      ],
      page: 1,
      last_page: 1,
      data: [],
      branches: [],
      warehouses: [],
      user: null,
      view: false,
      providers: {},
      form: {
        status: "",
        search: "",
        branch_id: "",
        warehouse_id: "",
        category_id: "",
        subcategory_id: "",
        brand_id: "",
        model_id: "",
        user_id: "",
        code: true,
        name: true,
        current_stock: true,
        total: false,
        price: false,
        price_max: false,
        price_offer: false,
        cost: false,
        committed: false,
        available: false,
        since: "",
        until: "",
      },
      categories: [],
      subcategories: [],
      brands: [],
      models: [],
      countPrice: 0,
      user_id:
        this.props.user.role === 4
          ? this.props.user.enterprise_users.enterprise_id
          : this.props.user.id,
      role: this.props.user.role,
      showProductsFilters: true,
      dates: {
        minDate: "",
        maxDate: "",
      },
    };
  }

  abortController = new AbortController();

  componentDidMount() {
    this.load();
    this.getThead();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  load = () => {
    this.products();
  };

  products = (resetPage = null) => {
    let {page, form} = this.state;

    if (typeof resetPage === "number") {
      page = resetPage;
    }

    form.user_id = this.props.user.id;

    axios
      .post("admin/reports/providers?page=" + page, form)
      .then((res) => {
        const responseData = res.data.providers || res.data;
        this.setState({
          last_page: responseData.last_page || 1,
          data: responseData.data || [],
        });
      })
      .catch((err) => {
        Globals.showError();
      });
  };

  warehouses = () => {
    let param = {
      role: this.props.user.role,
      user_id: this.props.user.id,
    };
    axios
      .post("admin/products/warehouses", param)
      .then((res) => {
        if (res.data.result) {
          let form = [];
          res.data.warehouses.forEach((el, i) => {
            form.push({
              id: el.id,
              name: el.name,
              stock_min: "",
              stock_max: "",
              price: "",
              location: "",
            });
          });
          this.setState({
            warehouses: form,
          });
        } else {
          Globals.showError(res.data.msg);
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  getWarehouses = (id) => {
    if (!id) {
      let warehouses_filtered = [];
      this.setState((state) => ({
        ...state,
        warehouses: warehouses_filtered,
        form: {
          ...state.form,
          warehouse_id: "",
        },
      }));
      return;
    }

    let {user} = this.props;
    const enterpriseId = (user.enterprise_users || {}).enterprise_id || user.id;

    Warehouse.getWarehouses({
      role: user.role,
      user_id: enterpriseId,
      branch_id: id,
    }).then((response) => {
      if (response.result) {
        let warehouses_filtered = [];
        if (user.role === 4) {
          warehouses_filtered = response.warehouses.data.filter((el) => {
            return user.assigned_warehouses.some((f) => {
              return parseInt(f.warehouse_id) === parseInt(el.id);
            });
          });
        } else {
          warehouses_filtered = response.warehouses.data;
        }

        this.setState((state) => ({
          warehouses: warehouses_filtered,
          form: {
            ...state.form,
            warehouse_id: "",
          },
        }));
      }
    });
  };

  getCategories = () => {
    let param = {
      role: this.props.user.role,
      user_id: this.props.user.id,
      select: true,
    };

    const {form} = this.state;

    Globals.setLoading();
    axios
      .post("admin/categories/get", param)
      .then(async (res) => {
        if (res.data.result) {
          this.setState({
            categories: res.data.categories,
            form: {
              ...form,
              subcategory_id: "",
            },
          });
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  getSubcategories = (categoryId) => {
    let param = {
      category_id: categoryId,
      select: true,
    };
    Category.getSubcategories(param).then((response) => {
      if (response.result) {
        this.setState((state) => ({
          ...state,
          subcategories: response.subcategories,
          form: {
            ...state.form,
            subcategory_id: "",
          },
        }));
      }
    });
  };

  getBrands = () => {
    let param = {
      role: this.props.user.role,
      user_id: this.props.user.id,
      select: true,
    };
    const {form} = this.state;
    Brand.getBrands(param).then((response) => {
      if (response.result) {
        this.setState({
          brands: response.brands,
          form: {
            ...form,
            model_id: "",
            brand_id: "",
          },
        });
      }
    });
  };

  getModels = (brandId) => {
    let param = {
      brand_id: brandId,
      select: true,
      user_id: this.props.user.id,
    };
    const {form} = this.state;
    Brand.getModels(param).then((response) => {
      if (response.result) {
        this.setState({
          models: response.models,
          form: {
            ...form,
            model_id: "",
          },
        });
      }
    });
  };

  openProductsDetails = (e) => {
    this.change(e);
    if (e.target.value === "")
      this.setState({
        showProductsFilters: false,
      });
    else
      this.setState({
        showProductsFilters: true,
      });
  };

  change = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleCheck = async (e) => {
    var {name, checked} = e.target;
    let {form, header, trows} = this.state;

    let sectionPrices = header
      .filter((Item) => Item.section === "price")
      .map((Item) => Item.value);

    let sectionStock = header
      .filter((Item) => Item.section === "stock")
      .map((Item) => Item.value);

    if (trows.length === 0) {
      trows = header.filter((Item) => Item.type === 1);
    } else {
      trows = trows.filter((Item) => Item.type);
    }

    let find = header.find((Item) => Item.value === name);

    if (sectionPrices.includes(name)) {
      if (!trows.find((Item) => Item.value === find.value)) {
        let countSecPrice = trows.filter((Item) => Item.section === "price");
        trows.push(find);

        if (countSecPrice.length === 0) {
          let totalRow = header.find((Item) => Item.value === "total");
          totalRow.multiplier = name;
          trows.push(totalRow);
        } else {
          let indexRow = trows.findIndex((Item) => Item.value === "total");
          if (indexRow > -1) {
            trows.splice(indexRow, 1);
          }
        }
      } else {
        let index2 = trows.findIndex((Item) => Item.value === name);
        trows.splice(index2, 1);

        let countSecPrice = trows.filter((Item) => Item.section === "price");

        if (countSecPrice.length === 1) {
          let totalRow = header.find((Item) => Item.value === "total");
          totalRow.multiplier = countSecPrice[0].value;
          trows.push(totalRow);
        } else {
          let indexRow = trows.findIndex((Item) => Item.value === "total");
          if (indexRow > -1) {
            trows.splice(indexRow, 1);
          }
        }
      }
    }

    if (sectionStock.includes(name)) {
      if (!trows.find((Item) => Item.value === find.value)) {
        let countSecStock = trows.filter((Item) => Item.section === "stock");
        trows.push(find);

        if (countSecStock.length === 0) {
          let totalAvailable = header.find(
            (Item) => Item.value === "available",
          );
          trows.push(totalAvailable);
        } else {
          let indexRow = trows.findIndex((Item) => Item.value === "available");
          if (indexRow > -1) {
            trows.splice(indexRow, 1);
          }
        }
      } else {
        let index2 = trows.findIndex((Item) => Item.value === name);
        trows.splice(index2, 1);

        let countSecStock = trows.filter((Item) => Item.section === "stock");

        if (countSecStock.length === 1) {
          let totalAvailable = header.find(
            (Item) => Item.value === "available",
          );
          trows.push(totalAvailable);
        } else {
          let indexRow = trows.findIndex((Item) => Item.value === "available");
          if (indexRow > -1) {
            trows.splice(indexRow, 1);
          }
        }
      }
    }

    trows.sort((a, b) => parseInt(a.order) - parseInt(b.order));

    let thead = trows.map((Item) => Item);

    this.setState({
      form: {
        ...form,
        [name]: checked,
      },
    });

    this.getThead(thead, trows);
  };

  getThead = async (arr = [], arr2 = []) => {
    const {header} = this.state;
    let newHeader = arr;

    if (newHeader.length === 0) {
      newHeader = header.filter((Item) => Item.type === 1);
    }

    await this.setState((state) => {
      state.thead = newHeader;
      state.trows = arr2;
    });
  };

  getBranches = () => {
    let {user} = this.props;
    const enterpriseId = (user.enterprise_users || {}).enterprise_id || user.id;

    Branch.getBranchesByEnterprise({Id: enterpriseId})
      .then((response) => {
        let branches_filtered = response.filter(({deleted_at}) => !deleted_at);

        branches_filtered = Format.rawBranches(
          branches_filtered,
          user.assigned_warehouses,
          user.role,
        );

        const branchesMap = branches_filtered
          .filter(({status}) => status === Constants.STATUS_ACTIVE)
          .map(({id, name}) => ({
            value: id,
            label: name,
          }));

        this.setState({
          branches: branchesMap,
        });
      })
      .catch(() => Globals.showError());
  };

  returnState = async () => {
    await this.setState((state) => ({
      ...state,
      search: "",
      form: {
        status: "",
        search: "",
        branch_id: "",
        warehouse_id: "",
        category_id: "",
        subcategory_id: "",
        brand_id: "",
        model_id: "",
        user_id: "",
      },
      thead: [],
      trows: [],
      optionals: [
        {value: "code", label: "Código", show: true},
        {value: "name", label: "Nombre", show: true},
        {value: "branch", label: "Almacen", show: true},
        {value: "warehouse", label: "Almacen", show: true},
        {value: "current_stock", label: "Existencia", show: true},
        {value: "available", label: "Disponible", show: true},
        {value: "total", label: "Total", show: true},
      ],
    }));
    await this.getThead();
    await this.load();
  };

  print = (data) => {
    axios
      .post("admin/reports/providers/download", this.state.form)
      .then((res) => {
        if (res.data.url_storage) {
          const url = `${ENV.BasePublic}${res.data.url_storage}`;
          const win = window.open(url, "_blank");
          win.focus();
        } else {
          Globals.showError("Ha ocurrido un error");
        }
      })
      .catch((err) => {
        Globals.showError();
      });
  };

  render() {
    return (
      <Menu history={this.props.history}>
        <div id="products" className="new-reports">
          <div className="row">
            <div className="col-md-4">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={this.state.form.since}
                onChange={(value) => {
                  this.setState((state) => ({
                    form: {
                      ...state.form,
                      since: value,
                    },
                  }));
                }}
              />
            </div>
            <div className="col-md-4">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={this.state.form.until}
                onChange={(value) => {
                  this.setState((state) => ({
                    form: {
                      ...state.form,
                      until: value,
                    },
                  }));
                }}
              />
            </div>
            <div className="col-md-4">
              <div className="container-buttons">
                <Button
                  className="btn-align-bottom btn-filter blue"
                  color=" "
                  onClick={this.load}
                >
                  <span>Filtrar</span>
                </Button>
                <Button
                  className="btn-align-bottom btn-filter"
                  color=" "
                  onClick={this.returnState}
                >
                  <span>Limpiar</span>
                </Button>
              </div>
            </div>
          </div>
          <div className="row" id="row1">
            <div className="col col-md d-flex flex-wrap justify-content-between align-items-center check">
              {this.state.optionals.map((el) => {
                if (!el.show) {
                  return (
                    <div key={el.value} className="px-3 py-3 check1">
                      <CheckBox
                        label={el.label}
                        name={el.value}
                        checked={this.state.form[el.value] ? true : false}
                        value={this.state.form[el.value]}
                        onChange={this.handleCheck}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
          <Table
            data={this.state.data.length}
            title="Proveedores"
            header={this.state.thead}
            right={
              <Button
                title="Imprimir"
                small="true"
                onClick={() => this.print(this.state.data)}
              >
                <img src={PrinterIcon} style={{width: 24}} alt="Imprimir" />
              </Button>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{i.razon_social || i.name || "-"}</td>
                  <td style={{maxWidth: "none", textAlign: "center"}}>
                    {Globals.formatMiles(Number(i.total_iva ?? i.total ?? 0))}
                  </td>
                  <td style={{maxWidth: "none", textAlign: "right"}}>
                    {Globals.formatMiles(Number(i.base_16 ?? i.total_bs ?? 0))}
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={async (page) => {
              await this.setState({
                page: page,
              });
              this.load();
            }}
          />
        </div>
      </Menu>
    );
  }
}

export default connect((state) => {
  return {
    user: state.user,
  };
})(ReportProviders);
